import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M12 5v.5m0 3v1.5m0 3v6","key":"svg-0"}],["path",{"d":"M16 15l-4 4","key":"svg-1"}],["path",{"d":"M8 15l4 4","key":"svg-2"}]]

const IconArrowNarrowDownDashed = createReactComponent('outline', 'arrow-narrow-down-dashed', 'ArrowNarrowDownDashed', __iconNode);

export default IconArrowNarrowDownDashed;